import React, { useEffect, useState } from "react";
import customHttp from "../../services/customHTTP";
import { Box, IconButton, Tooltip, CircularProgress } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AddCircle, ChevronLeft, ChevronRight, Delete } from "@mui/icons-material";
import Datagrid from "../Datagrid/Datagrid";
const ManageProductsMaster = () => {
	const [allProducts, setAllProducts] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");

	useEffect(() => {
		const fetchAllProducts = async () => {
			try {
				const response = await customHttp.get("/products");
				console.log(response.data.data);
				setAllProducts(response.data.data);
			} catch (error) {
				setError(error.message);
			} finally {
				setLoading(false);
			}
		};
		fetchAllProducts();
	}, []);

	const handleEdit = (product) => {
		console.log(product);
	};

	const columns = [
		{ field: "product_number", headerName: "Product Number", width: 200 },
		{ field: "product_name", headerName: "Product Name", flex: 1 },
		{
			headerName: "Actions",
			sortable: false,
			width: 100, // Ensure there's enough space for icons
			headerAlign: "center",
			align: "left",
			renderCell: (params) => (
				<div>
					<Tooltip title="Edit User">
						<IconButton
							color="primary"
							aria-label="Edit User"
							onClick={(event) => {
								event.stopPropagation();
								handleEdit(params.row);
							}}>
							<EditIcon />
						</IconButton>
					</Tooltip>
				</div>
			),
		},
	];

	const customButtons = [
		{
			label: "Upload New Products",
			icon: <AddCircle />,
			onClick: () => {
				console.log("Upload New Products");
			},
		},
		{
			label: "Delete Selected",
			icon: <Delete />,
			onClick: () => {},
		},
	];

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "40vh" }}>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<div>
			<Datagrid
				loading={loading}
				data={allProducts}
				columns={columns}
				customButtons={customButtons}
				checkboxSelection={true}
				rowIdField="product_id"
				sortBy={[{ field: "product_id", sort: "asc" }]}
			/>
		</div>
	);
};

export default ManageProductsMaster;
